import React, { Suspense, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { ResourceAbility } from '../../../libs/security/authorization'
import { GenericPageHeaderSkeleton } from '../../../components/page-headers/GenericPageHeader';
import IdentityView from 'libs/resources/identity/applications/IdentityView';

const IdentityApplicationCreate = lazy(() => import('../../../libs/resources/identity/applications/IdentityApplicationCreate'));
const IdentityApplicationList = lazy(() => import('../../../libs/resources/identity/applications/IdentityApplicationList'));
const IdentityApplicationView = lazy(() => import('../../../libs/resources/identity/applications/IdentityApplicationView'));

interface IdentityApplicationRouteProps {

}

const fallPermission = <div className="message info">
    <FormattedMessage defaultMessage="You do not have permission to access the page. Please contact your Team owner." />
</div>

function IdentityApplicationRoute(props: IdentityApplicationRouteProps) {
    return (
        <Suspense fallback={<GenericPageHeaderSkeleton />}>
            <Switch>
                <Route exact path="/home/applications" render={() => (<Redirect to="/home/applications/list" />)} />

                <Route path="/home/applications/list" render={() => (
                    <ResourceAbility can="read" resource={({ Application }) => [
                        Application.list.environment["trimble-pre-prod"],
                        Application.list.environment["trimble-prod"], Application.listByUser.environment["trimble-pre-prod"],
                        Application.listByUser.environment["trimble-prod"]]}
                        fallBack={fallPermission} >
                        <IdentityView />
                    </ResourceAbility>
                )} />

                <Route path="/home/applications/create" render={() => (
                    <ResourceAbility can="read" resource={({ Application }) => [
                        Application.create.environment["trimble-prod"],
                        Application.create.environment["trimble-pre-prod"]
                    ]} fallBack={fallPermission} >
                        <IdentityApplicationCreate />
                    </ResourceAbility>
                )} />

                <Route exact path="/home/applications/:applicationName/gateway/:environmentName/summary" render={() => (
                    <ResourceAbility can="read" resource={({ Application }) => [
                        Application.list.environment["trimble-pre-prod"],
                        Application.list.environment["trimble-prod"], Application.listByUser.environment["trimble-pre-prod"],
                        Application.listByUser.environment["trimble-prod"]]}
                        fallBack={fallPermission} >
                        <IdentityApplicationView />
                    </ResourceAbility>
                )} />
            </Switch>
        </Suspense>
    )
}

IdentityApplicationRoute.propTypes = {

}

export default IdentityApplicationRoute

